module.exports = __webpack_public_path__ + "img/zlindex14.af09caeb.png";